import {ScoData} from "../scorm/sco";
import {ScoNavItem} from "../scorm/manifest";
import {SSLAConfiguration} from "../config";

export function initializeApiShared(i: ScoData, scoNav: ScoNavItem, config: SSLAConfiguration) {
    i.set("cmi.learner_id", config.studentId());
    i.set("cmi.learner_name", config.studentName());
    if (config.launchDataAllowOverride(scoNav.identifier)) {
        i.set("cmi.launch_data", config.launchDataOverride(scoNav.identifier));
    } else {
        // TODO dataFromLms needs to distinguish between "non-existent" and "exists but empty".
        //   And then the set behavior needs to apply here
        //   Otherwise we can't correctly 403 when cmi.launch_data is asked for.
        i.set("cmi.launch_data", scoNav.dataFromLms);
    }
    i.set("cmi.max_time_allowed", scoNav.maxTimeAllowed);
    i.set("cmi.time_limit_action", scoNav.timeLimitAction);
    if (config.getCredit()) {
        i.set("cmi.credit", config.getCredit());
    }
    if (config.getMode()) {
        i.set("cmi.mode", config.getMode());
    }
    let comments = config.commentsFromLMS(scoNav.identifier);
    if (comments && comments.length > 0) {
        for (let j=0; j < comments.length; j++) {
            // @ts-ignore
            i.set("cmi.comments_from_lms." + j + ".comment", comments[0]["comment"]);
            // @ts-ignore
            i.set("cmi.comments_from_lms." + j + ".location", comments[0]["location"]);
            // @ts-ignore
            i.set("cmi.comments_from_lms." + j + ".timestamp", comments[0]["timestamp"]);
        }
        i.set("cmi.comments_from_lms._count", comments.length + "");
    }

    // Some keys should not be preserved when preparing a new SCO, clear them out.
    i.clear("adl.nav.request");
}
